import alpacaLogo from '../assets/broker-logos/alpaca.webp';
import bitunixLogo from '../assets/broker-logos/bitunix.webp';
import coinbaseLogo from '../assets/broker-logos/coinbase.webp';
import krakenLogo from '../assets/broker-logos/kraken.webp';
import schwabLogo from '../assets/broker-logos/schwab.webp';
import tradierLogo from '../assets/broker-logos/tradier.webp';
import tradovateLogo from '../assets/broker-logos/tradovate.webp';
import weexLogo from '../assets/broker-logos/weex.webp';
const {
  ALL_BROKER_CONNECTION_SOURCE,
  BROKER_CONNECTION_SOURCE,
  PROJECTX_FIRM_SOURCE,
} = require('../site/brokerConnectionSource');

const UNLISTED_BROKER_NAMES = {
  ibrest: 'Interactive Brokers REST',
  interactivebrokersrest: 'Interactive Brokers REST',
};

const IBKR_BROKER_IDS = new Set(Object.keys(UNLISTED_BROKER_NAMES));

const brokerLogosById = {
  alpaca: alpacaLogo,
  bitunix: bitunixLogo,
  coinbase: coinbaseLogo,
  kraken: krakenLogo,
  schwab: schwabLogo,
  tradier: tradierLogo,
  tradovate: tradovateLogo,
  weex: weexLogo,
};

function hydrateBrokerConnectionForUi(broker) {
  return {
    ...broker,
    logoPath: brokerLogosById[broker.id] || null,
  };
}

export const BROKER_CONNECTIONS = BROKER_CONNECTION_SOURCE.map(hydrateBrokerConnectionForUi);
export const PROJECTX_FIRMS = PROJECTX_FIRM_SOURCE.map(hydrateBrokerConnectionForUi);
export const ALL_BROKER_CONNECTIONS = ALL_BROKER_CONNECTION_SOURCE.map(hydrateBrokerConnectionForUi);

function humanizeBrokerId(id) {
  return id
    .replace(/[_-]+/g, ' ')
    .replace(/\b\w/g, (character) => character.toUpperCase());
}

function buildUnlistedBrokerConnection(id) {
  const normalizedId = String(id || '').trim().toLowerCase() || 'unknown';
  const isIbkr = IBKR_BROKER_IDS.has(normalizedId);
  return {
    id: normalizedId,
    name: UNLISTED_BROKER_NAMES[normalizedId] || humanizeBrokerId(normalizedId),
    logoPath: null,
    logoText: isIbkr ? 'IBKR' : null,
    assetClasses: [],
    tags: [],
    modes: isIbkr ? ['paper'] : ['paper', 'live'],
    authMethods: [],
    credentialFields: [],
    unlisted: true,
  };
}

export function findBrokerConnection(id) {
  const normalizedId = String(id || '').trim().toLowerCase();
  return ALL_BROKER_CONNECTIONS.find((broker) => broker.id === normalizedId)
    || buildUnlistedBrokerConnection(normalizedId);
}
